export default __webpack_public_path__ + "navigation-overview-carplay-1200-0efecfc2985141eae16719b0cf277001.webp";